module.exports = __webpack_public_path__ + "img/ggm_logo_mini.3160fe16.jpg";